export default "__VITE_ASSET__DiFQMByX__"